// @ts-check
// Ambiente em que a tela está (produção, homologação ou desenvolvimento), lido uma vez de /health sem bloquear a
// abertura; fora da produção o menu e as telas de entrada mostram o selo, para ninguém testar na produção por engano.
import { signal } from '@preact/signals';
import { normalizeAppEnvironment } from '../../../shared/app-environment.js';

/** @type {import('@preact/signals').Signal<'production' | 'staging' | 'development'>} */
export const appEnvironmentState = signal('production');

/** @param {{ isMock: boolean, fetchHealth?: () => Promise<Response> }} options */
export async function loadAppEnvironment({ isMock, fetchHealth = () => fetch('/health', { headers: { Accept: 'application/json' } }) }) {
  // o modo demonstração não tem servidor: fica como produção, sem selo
  if (isMock) return appEnvironmentState.value;
  try {
    const response = await fetchHealth();
    if (!response.ok) return appEnvironmentState.value;
    const body = await response.json();
    appEnvironmentState.value = normalizeAppEnvironment(body?.environment);
  } catch {
    // sem /health a tela segue como produção
  }
  return appEnvironmentState.value;
}
